<template>
  <transition-group name="list-facets-available" tag="div" class="contents">
    <media-archive-facet
      v-for="facet in facets"
      :key="facet.type"
      v-bind="facet"
    >
      <template #tagsLabel>Zoek op domein</template>
      <template #tags="{ item: tag }">
        {{ tag.title }}
      </template>

      <template #volumesLabel>Jaargang</template>
      <template #volumes="{ item: volume }">
        jaargang {{ volume.volumeNumber }}: {{ volume.title }}
      </template>

      <template #seasonsLabel>Aflevering</template>
      <template #seasons="{ item: season }">
        nummer {{ season.issueNumber }}
      </template>
    </media-archive-facet>
  </transition-group>
</template>

<script>
import MediaArchiveFacet from "./MediaArchiveFacet.vue";

export default {
  name: "MediaArchiveFacetsAvailable",
  components: {
    MediaArchiveFacet,
  },
  props: {
    facets: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="css">
/* Transitions */

.list-facets-available-enter-active,
.list-facets-available-leave-active {
  opacity: 1;
  transition: opacity 300ms ease;
}

.list-facets-available-move {
  transition: transform 0.3s ease;
}

.list-facets-available-enter-from,
.list-facets-available-leave-to {
  opacity: 0;
}

.list-facets-available-leave-active {
  position: absolute;
}
</style>
